import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectBookingSummaryForEvent } from '.';
import { requestBookingSummaryList } from '..';

export const useBookingSummary = (eventId: string) => {
  const dispatch = useDispatch();
  const bookingSummary = useSelector(selectBookingSummaryForEvent(eventId));
  const getBookingSummary = bindActionCreators(requestBookingSummaryList, dispatch);

  useEffect(() => {
    if (eventId) {
      getBookingSummary({
        eventIds: [eventId],
      });
    }
  }, [eventId]);

  return { bookingSummary };
};
